<template>
  <div id="new_user">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <div id="content">
        <dd-sitemap
          :pageKey="pageKey"
          :pageList="pageList"
        />
        <div class="title">
          <h1>登録情報確認</h1>
        </div>
        <section v-if="isNewCorp && !isInviteUser">
          <h3 v-if="isPrivateUser">会員連絡先</h3>
          <h3 v-else>企業情報</h3>
          <dd-corp-confirm
            :corpForm="corpForm"
            :isPrivateUser="isPrivateUser"
            :isEdit="false"
          />
        </section>
        <section>
          <h3>ユーザー情報</h3>
          <dd-user-confirm
            :userForm="userForm"
            :isPrivateUser="isPrivateUser"
            :isEdit="false"
          />
        </section>
        <div class="control_btn_area">
          <div class="detail_btn2" @click="reEdit()">内容を修正する</div>
          <div class="detail_btn" @click="newUser()">本会員登録へ</div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import DDLeftMenu from '../components/top/DcLeftMenu'
import SiteMap from '../components/common/DcSiteMap'
import CorpConfirm from '../components/user/DcCorpConfirm'
import UserConfirm from '../components/user/DcUserConfirm'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': SiteMap,
    'dd-corp-confirm': CorpConfirm,
    'dd-user-confirm': UserConfirm,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      pageKey: 'dcRegistConfirm',
      pageList: [
        {id: 'dcRegistInput', key: 'dcRegistInput', title: '会員情報入力'},
        {id: 'dcRegistConfirm', key: 'dcRegistConfirm', title: '内容確認'},
        {id: 'dcRegistComplete', key: 'dcRegistComplete', title: '登録完了'}
      ],
      corpForm: {
        corpUserId: '',
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        inviteCode: '',
        requestPayment: ''
      },
      userForm: {
        corpUserId: '',
        corpType: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        infosrc: '',
        recvInfo: '',
        consent: '',
        password: '',
        confirmPassword: ''
      },
      errorMessage: { text: '' },
      validateErrorMessages: {},
      userType: false
    }
  },
  computed: {
    isNewCorp: function () {
      // ユーザ情報がない場合
      if (!this.userForm || this.userForm.corpUserId === undefined || this.userForm.corpUserId === '') {
        return true
      }
      return false
    },
    isPrivateUser: function () {
      if (this.userType) {
        return true
      }
      return false
    },
    isInviteUser: function () {
      if (this.userForm.corpUserId) {
        return true
      }
      return false
    },
    corpDate: function () {
      let payload = {
        corpType: this.userForm.corpType,
        corpName: this.corpForm.corpName,
        corpBranchName: this.corpForm.corpBranchName,
        corpDept: this.userForm.corpDept,
        userLastName: this.userForm.userLastName,
        userFirstName: this.userForm.userFirstName,
        userLastNameKana: this.userForm.userLastNameKana,
        userFirstNameKana: this.userForm.userFirstNameKana,
        email: this.userForm.email,
        tel: this.corpForm.tel,
        fax: this.corpForm.fax,
        postcd: this.corpForm.postcd,
        state: this.corpForm.state,
        city: this.corpForm.city,
        street: this.corpForm.street,
        infosrc: this.userForm.infosrc,
        inviteCode: this.corpForm.inviteCode,
        requestPayment: this.corpForm.requestPayment,
        recvInfo: this.userForm.recvInfo,
        password: this.userForm.password,
        confirmPassword: this.userForm.confirmPassword
      }
      return payload
    }
  },
  methods: {
    reEdit: function () {
      this.$router.go(-1)
    },
    fetchData: function () {
      this.corpForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
      this.userForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    },
    newUser: function () {
      this.$refs.loadingModalRef.showModal(true)
      if (this.isPrivateUser) {
        axios.post(DC_URL.USER + '/new/regist-pri-user', this.corpDate)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
              this.$router.push({
                name: 'RegistUserComplete',
                query: {type: this.userType}
              })
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      } else if (this.isNewCorp) {
        // 企業ユーザ
        axios.post(DC_URL.USER + '/new/regist-user', this.corpDate)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
              this.$router.push({
                name: 'RegistUserComplete',
                query: {type: this.userType}
              })
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      } else {
        // 招待ユーザ
        let payload = {
          corpUserId: this.userForm.corpUserId,
          corpType: this.userForm.corpType,
          corpDept: this.userForm.corpDept,
          userLastName: this.userForm.userLastName,
          userFirstName: this.userForm.userFirstName,
          userLastNameKana: this.userForm.userLastNameKana,
          userFirstNameKana: this.userForm.userFirstNameKana,
          email: this.userForm.email,
          password: this.userForm.password,
          confirmPassword: this.userForm.confirmPassword,
          infosrc: this.userForm.infosrc,
          recvInfo: this.userForm.recvInfo
        }
        axios.post(DC_URL.USER + '/new/regist-user-account', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
              this.$router.push({
                name: 'RegistUserComplete',
                query: {type: true}
              })
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      }
    }
  },
  created () {
    this.fetchData()
    if (!this.isInviteUser) {
      this.userType = App.getLocalStorage(DC_STORAGE_KEY.USER_TYPE)
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcRegistUserConfirm.vue